import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { connect } from 'react-redux';
import { getNCFileByPartId } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByPart, operationsSearch } from '@reducers/search';
import { usePartDetails } from '@v2/pages/common/hooks/usePartDetails';
import { getPartByID } from '@reducers/parts';
import MultiMachineTimeline from '@v2/pages/common/components/MultiMachineTimeline';

interface PartDetailsPartTimelineProps {
}

const PartDetailsPartTimelineComponent: FC<PartDetailsPartTimelineProps> = ({
  clearTools,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  getNCFileByPartId,
  operationsSearch,
}) => {
  const title = useTitle();

  usePartDetails({
    clearTools,
    getNCFileByPartId,
    getTools,
    updateHeaderConfig,
    getProductionBatchByPart,
    getPartByID,
    operationsSearch,
  });

  return (
    <DetailsPageWrapper title={title.part}>
       <MultiMachineTimeline />
    </DetailsPageWrapper>
  );
};

const PartDetailsPartTimeline = connect(null, {
  clearTools,
  getNCFileByPartId,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  operationsSearch,
})(PartDetailsPartTimelineComponent);

export { PartDetailsPartTimeline };
